import { useMemo } from "react";
import { useFetch } from "../useFetch";
import { PagedResultDto } from "../../types/api/PagedResultDto";
import { Geofence } from "../../types/api/guide/geofence.types";
import { geofenceService } from "../../services/guide/geofence-service";

export const useFetchPagedGeofence = (page: number, pageSize: number, name?: string) => {
    const params = useMemo(() => [page, pageSize, name] as const, [page, pageSize, name]);
    return useFetch<PagedResultDto<Geofence>>(geofenceService.getPaged, params as unknown as [number, number, string?]);
};
